module.exports = __webpack_public_path__ + "static/media/wsLogo.206ca868.PNG";